export default [
    {
        "code": "R10",
        "nom": "Tétrachlorométhane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": 1.1,
        "inflammable": false
    },
    {
        "code": "R11",
        "nom": "Trichlorofluorométhane",
        "type": "CFC",
        "prg": 4750,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R12",
        "nom": "Dichlorodifluorométhane",
        "type": "CFC",
        "prg": 8100,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R13",
        "nom": "Chlorotrifluorométhane",
        "type": "CFC",
        "prg": 14000,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R14",
        "nom": "Tétrafluorométhane",
        "type": "PFC",
        "prg": 6500,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R21",
        "nom": "Dichlorofluorométhane",
        "type": "HCFC",
        "prg": null,
        "odp": 0.04,
        "inflammable": false
    },
    {
        "code": "R22",
        "nom": "Chlorodifluorométhane",
        "type": "HCFC",
        "prg": 1500,
        "odp": 0.055,
        "inflammable": false
    },
    {
        "code": "R23",
        "nom": "Trifluorométhane",
        "type": "HFC",
        "prg": 14800,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R30",
        "nom": "Dichlorométhane",
        "type": "Chloroalcane",
        "prg": 9,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R31",
        "nom": "Chlorofluorométhane",
        "type": "HCFC",
        "prg": null,
        "odp": 0.02,
        "inflammable": false
    },
    {
        "code": "R32",
        "nom": "Difluorométhane",
        "type": "HFC",
        "prg": 650,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R40",
        "nom": "Chlorométhane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R41",
        "nom": "Fluorométhane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R50",
        "nom": "Méthane",
        "type": "Alcane",
        "prg": 21,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R110",
        "nom": "Hexachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R111",
        "nom": "Pentachlorofluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R112",
        "nom": "1,1,2,2-Tétrachloro-1,2-difluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R112a",
        "nom": "1,1,1,2-Tétrachloro-2,2-difluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R113",
        "nom": "1,1,2-Trichloro-1,2,2-trifluoroéthane",
        "type": "CFC",
        "prg": 4800,
        "odp": 0.8,
        "inflammable": false
    },
    {
        "code": "R113a",
        "nom": "1,1,1-Trichloro-2,2,2-trifluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R114",
        "nom": "1,2-Dichloro-1,1,2,2-tétrafluoroéthane",
        "type": "CFC",
        "prg": 9800,
        "odp": 1,
        "inflammable": false
    },
    {
        "code": "R114a",
        "nom": "1,1-Dichloro-1,2,2,2-tétrafluoroéthane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R115",
        "nom": "Chloropentafluoroéthane",
        "type": "CFC",
        "prg": 7200,
        "odp": 0.6,
        "inflammable": false
    },
    {
        "code": "R116",
        "nom": "Hexafluoroéthane",
        "type": "PFC",
        "prg": 9200,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R120",
        "nom": "Pentachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R121",
        "nom": "1,1,2,2-Tétrachloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R121a",
        "nom": "1,1,1,2-Tétrachloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R122",
        "nom": "1,1,2-Trichloro-2,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R122a",
        "nom": "1,1,2-Trichloro-1,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R122b",
        "nom": "1,1,1-Trichloro-2,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R123",
        "nom": "2,2-dichloro-1,1,1-trifluoroéthane",
        "type": "HCFC",
        "prg": 90,
        "odp": 0.02,
        "inflammable": false
    },
    {
        "code": "R123a",
        "nom": "1,2-Dichloro-1,1,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R123b",
        "nom": "1,1-Dichloro-1,2,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R124",
        "nom": "1-Chloro-1,2,2,2-tétrafluoroéthane",
        "type": "HCFC",
        "prg": 470,
        "odp": 0.022,
        "inflammable": false
    },
    {
        "code": "R124a",
        "nom": "1-Chloro-1,1,2,2-tétrafluoroéthane",
        "type": "HCFC",
        "prg": 620,
        "odp": 0.022,
        "inflammable": false
    },
    {
        "code": "R125",
        "nom": "Pentafluoroéthane",
        "type": "HFC",
        "prg": 2800,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE125",
        "nom": "Difluorométhoxytrifluorométhane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R130",
        "nom": "1,1,2,2-Tétrachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R130a",
        "nom": "1,1,1,2-Tétrachloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R131",
        "nom": "1,1,2-Trichloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R131a",
        "nom": "1,1,2-Trichloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R131b",
        "nom": "1,1,1-Trichloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132",
        "nom": "Dichlorodifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132a",
        "nom": "1,1-Dichloro-2,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132b",
        "nom": "1,2-Dichloro-1,1-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R132c",
        "nom": "1,1-Dichloro-1,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R133",
        "nom": "1-Chloro-1,2,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R133a",
        "nom": "1-Chloro-2,2,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": 0.06,
        "inflammable": false
    },
    {
        "code": "R133b",
        "nom": "1-Chloro-1,1,2-trifluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R134",
        "nom": "1,1,2,2-Tétrafluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R134a",
        "nom": "1,1,1,2-Tétrafluoroéthane",
        "type": "HFC",
        "prg": 1300,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE134",
        "nom": "Difluorométhoxydifluorométhane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R140",
        "nom": "1,1,2-trichloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R140a",
        "nom": "1,1,1-trichloroéthane",
        "type": "Chloroalcane",
        "prg": null,
        "odp": 0.1,
        "inflammable": false
    },
    {
        "code": "R141",
        "nom": "1,2-dichloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R141a",
        "nom": "1,1-dichloro-2-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R141b",
        "nom": "1,1-dichloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": 600,
        "odp": 0.11,
        "inflammable": false
    },
    {
        "code": "R142a",
        "nom": "1-chloro-1,2-difluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R142b",
        "nom": "1-chloro-1,1-difluoroéthane",
        "type": "HCFC",
        "prg": 1800,
        "odp": 0.065,
        "inflammable": false
    },
    {
        "code": "R143",
        "nom": "1,1,2-trifluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R143a",
        "nom": "1,1,1-trifluoroéthane",
        "type": "HFC",
        "prg": 3800,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R143m",
        "nom": "Méthoxytrifluorométhane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "RE143a",
        "nom": "Méthoxy-2,2,2-trifluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R151",
        "nom": "Chlorofluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R151a",
        "nom": "1-chloro-1-fluoroéthane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R152",
        "nom": "1,2-difluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R152a",
        "nom": "1,1-difluoroéthane",
        "type": "HFC",
        "prg": 140,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R161",
        "nom": "Fluoroéthane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R170",
        "nom": "Éthane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R211",
        "nom": "1,1,1,2,2,3,3-heptachloro-3-fluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R212",
        "nom": "Hexachlorodifluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R213",
        "nom": "1,1,1,3,3-pentachloro-2,2,3-trifluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R214",
        "nom": "1,2,2,3-tétrachloro-1,1,3,3-tétrafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R215",
        "nom": "1,1,1-trichloro-2,2,3,3,3-pentafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R216",
        "nom": "1,2-dichloro-1,1,2,3,3,3-hexafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R216ca",
        "nom": "1,3-dichloro-1,1,2,2,3,3-hexafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R217",
        "nom": "1-chloro-1,1,2,2,3,3,3-heptafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R217ba",
        "nom": "2-chloro-1,1,1,2,3,3,3-heptafluoropropane",
        "type": "CFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R218",
        "nom": "Octafluoropropane",
        "type": "PFC",
        "prg": 7000,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R221",
        "nom": "1,1,1,2,2,3-hexachloro-3-fluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R222",
        "nom": "Pentachlorodifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R222c",
        "nom": "1,1,1,3,3-pentachloro-2,2-difluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R223",
        "nom": "Téetrachlorotrifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R223ca",
        "nom": "1,1,3,3-tétrachloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R223cb",
        "nom": "1,1,1,3-tétrachloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224",
        "nom": "Trichlorotétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224ca",
        "nom": "1,3,3-trichloro-1,1,2,2-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224cb",
        "nom": "1,1,3-trichloro-1,2,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R224cc",
        "nom": "1,1,1-trichloro-2,2,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225",
        "nom": "dichloropentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225aa",
        "nom": "2,2-dichloro-1,1,1,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225ba",
        "nom": "2,3-dichloro-1,1,1,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225bb",
        "nom": "1,2-dichloro-1,1,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225ca",
        "nom": "3,3-dichloro-1,1,1,2,2-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225cb",
        "nom": "1,3-dichloro-1,1,2,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": 0.07,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225cc",
        "nom": "1,1-dichloro-1,2,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225da",
        "nom": "1,2-dichloro-1,1,3,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225ea",
        "nom": "1,3-dichloro-1,1,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R225eb",
        "nom": "1,1-dichloro-1,2,3,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226",
        "nom": "Chlorohexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226ba",
        "nom": "2-chloro-1,1,1,2,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226ca",
        "nom": "3-chloro-1,1,1,2,2,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226cb",
        "nom": "1-chloro-1,1,2,2,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226da",
        "nom": "2-chloro-1,1,1,3,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R226ea",
        "nom": "1-chloro-1,1,2,3,3,3-hexafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R227ca",
        "nom": "1,1,2,2,3,3,3-heptafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R227ca2",
        "nom": "Trifluorométhoxy-1,1,2,2-tétrafluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R227ea",
        "nom": "1,1,1,2,3,3,3-heptafluoropropane",
        "type": "HFC",
        "prg": 2900,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R227me",
        "nom": "Trifluorométhoxy-1,2,2,2-tétrafluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R231",
        "nom": "Pentachlorofluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R232",
        "nom": "Tétrachlorodifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R232ca",
        "nom": "1,1,3,3-tétrachloro-2,2-difluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R232cb",
        "nom": "1,1,1,3-tétrachloro-2,2-difluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233",
        "nom": "Trichlorotrifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233ca",
        "nom": "1,1,3-trichloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233cb",
        "nom": "1,1,3-trichloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R233cc",
        "nom": "1,1,1-trichloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234",
        "nom": "Dichlorotétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234aa",
        "nom": "2,2-dichloro-1,1,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234ab",
        "nom": "2,2-dichloro-1,1,1,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234ba",
        "nom": "1,2-dichloro-1,2,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234bb",
        "nom": "2,3-dichloro-1,1,1,2-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234bc",
        "nom": "1,2-dichloro-1,1,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234ca",
        "nom": "1,3-dichloro-1,2,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234cb",
        "nom": "1,1-dichloro-2,2,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234cc",
        "nom": "1,3-dichloro-1,1,2,2-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234cd",
        "nom": "1,1-dichloro-1,2,2,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234da",
        "nom": "2,3-dichloro-1,1,1,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234fa",
        "nom": "1,3-dichloro-1,1,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R234fb",
        "nom": "1,1-dichloro-1,3,3,3-tétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235",
        "nom": "Chloropentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235ca",
        "nom": "1-chloro-1,2,2,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235cb",
        "nom": "3-chloro-1,1,1,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235cc",
        "nom": "1-chloro-1,1,2,2,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235da",
        "nom": "2-chloro-1,1,1,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R235fa",
        "nom": "1-chloro-1,1,3,3,3-pentafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236cb",
        "nom": "1,1,1,2,2,3-hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236ea",
        "nom": "1,1,1,2,3,3-hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236fa",
        "nom": "1,1,1,3,3,3-Hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R236me",
        "nom": "2-(difluorométhoxy)-1,1,1,2-tétrafluoroéthane",
        "type": "Éther halogéné",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "RFE-36",
        "nom": "Hexafluoropropane",
        "type": "HFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R241",
        "nom": "Tétrachlorofluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R242",
        "nom": "Trichlorodifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243",
        "nom": "Dichlorotrifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243ca",
        "nom": "1,3-dichloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243cb",
        "nom": "1,1-dichloro-2,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243cc",
        "nom": "1,1-dichloro-1,2,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243da",
        "nom": "2,3-dichloro-1,1,1-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243ea",
        "nom": "1,3-dichloro-1,2,3-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R243ec",
        "nom": "1,3-dichloro-1,1,2-trifluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R244",
        "nom": "Chlorotétrafluoropropane",
        "type": "HCFC",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R290",
        "nom": "Propane",
        "type": "Alcane",
        "prg": 3.3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R600a",
        "nom": "2-Méthylpropane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1130",
        "nom": "1,2-dichloroéthylène",
        "type": "Chloroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1132",
        "nom": "1,1-Difluoroéthylène",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1140",
        "nom": "Chlorure de vinyle",
        "type": "Chloroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1141",
        "nom": "Fluoroéthylène",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1150",
        "nom": "Éthylène",
        "type": "Alcène",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1216",
        "nom": "Hexafluoropropène",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1218",
        "nom": "Hexafluoropropène (trimère)",
        "type": "Fluoroalcène",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1234ze",
        "nom": "Tétrafluoropropène",
        "type": "HFC",
        "prg": 6,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1270",
        "nom": "Propylène",
        "type": "Alcène",
        "prg": 3,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R410A",
        "nom": "R410A",
        "type": "HFC (mélange R32 / R125)",
        "prg": 2088,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R513A",
        "nom": "R513A",
        "type": "HFO/HFC (mélange R1234yf / R134a)",
        "prg": 631,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R600",
        "nom": "Butane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R601",
        "nom": "Pentane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R601a",
        "nom": "Isopentane",
        "type": "Alcane",
        "prg": 3,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R702",
        "nom": "Hydrogène",
        "type": "Fluide naturel",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R704",
        "nom": "Hélium",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R717",
        "nom": "Ammoniac",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R718",
        "nom": "Eau",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R720",
        "nom": "Néon",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R728",
        "nom": "Azote",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R729",
        "nom": "Air",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R732",
        "nom": "Oxygène",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R740",
        "nom": "Argon",
        "type": "Fluide naturel",
        "prg": 0,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R744",
        "nom": "Dioxyde de carbone",
        "type": "Fluide naturel",
        "prg": 1,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R744A",
        "nom": "Oxyde nitreux",
        "type": "Fluide naturel",
        "prg": 298,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R764",
        "nom": "Dioxyde de soufre",
        "type": "Fluide naturel",
        "prg": null,
        "odp": 0,
        "inflammable": false
    },
    // ─── HFO purs ────────────────────────────────────────────────────────
    {
        "code": "R1234yf",
        "nom": "2,3,3,3-Tétrafluoropropène",
        "type": "HFO",
        "prg": 4,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R1234ze(E)",
        "nom": "trans-1,3,3,3-Tétrafluoropropène",
        "type": "HFO",
        "prg": 7,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1234ze(Z)",
        "nom": "cis-1,3,3,3-Tétrafluoropropène",
        "type": "HFO",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R1233zd(E)",
        "nom": "trans-1-Chloro-3,3,3-trifluoropropène",
        "type": "HCFO",
        "prg": 1,
        "odp": 0.00024,
        "inflammable": false
    },
    {
        "code": "R1233zd(Z)",
        "nom": "cis-1-Chloro-3,3,3-trifluoropropène",
        "type": "HCFO",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1224yd(Z)",
        "nom": "cis-1-Chloro-2,3,3,3-tétrafluoropropène",
        "type": "HCFO",
        "prg": 1,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R1243zf",
        "nom": "3,3,3-Trifluoropropène",
        "type": "HFO",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R1336mzz(Z)",
        "nom": "cis-1,1,1,4,4,4-Hexafluorobut-2-ène",
        "type": "HFO",
        "prg": 2,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1336mzz(E)",
        "nom": "trans-1,1,1,4,4,4-Hexafluorobut-2-ène",
        "type": "HFO",
        "prg": null,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R1123",
        "nom": "Trifluoroéthylène",
        "type": "HFO",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    // ─── Mélanges azéotropiques classiques (R500) ─────────────────────
    {
        "code": "R500",
        "nom": "R500 (mélange R12 / R152a)",
        "type": "CFC/HFC (mélange azéotropique)",
        "prg": 4345,
        "odp": 0.605,
        "inflammable": false
    },
    {
        "code": "R501",
        "nom": "R501 (mélange R22 / R12)",
        "type": "HCFC/CFC (mélange azéotropique)",
        "prg": null,
        "odp": 0.3,
        "inflammable": false
    },
    {
        "code": "R502",
        "nom": "R502 (mélange R22 / R115)",
        "type": "HCFC/CFC (mélange azéotropique)",
        "prg": 4657,
        "odp": 0.221,
        "inflammable": false
    },
    {
        "code": "R503",
        "nom": "R503 (mélange R23 / R13)",
        "type": "HFC/CFC (mélange azéotropique)",
        "prg": null,
        "odp": 0.599,
        "inflammable": false
    },
    {
        "code": "R504",
        "nom": "R504 (mélange R32 / R115)",
        "type": "HFC/CFC (mélange azéotropique)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R505",
        "nom": "R505 (mélange R12 / R31)",
        "type": "CFC/HCFC (mélange azéotropique)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R506",
        "nom": "R506 (mélange R31 / R114)",
        "type": "HCFC/CFC (mélange azéotropique)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R507A",
        "nom": "R507A (mélange R125 / R143a)",
        "type": "HFC (mélange azéotropique)",
        "prg": 3985,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R508A",
        "nom": "R508A (mélange R23 / R116)",
        "type": "HFC (mélange azéotropique)",
        "prg": 13214,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R508B",
        "nom": "R508B (mélange R23 / R116)",
        "type": "HFC (mélange azéotropique)",
        "prg": 13396,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R509A",
        "nom": "R509A (mélange R22 / R218)",
        "type": "HCFC/PFC (mélange azéotropique)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    // ─── Mélanges quasi-azéotropiques HFC (R400) ──────────────────────
    {
        "code": "R401A",
        "nom": "R401A (mélange R22 / R152a / R124)",
        "type": "HCFC/HFC (mélange)",
        "prg": null,
        "odp": 0.037,
        "inflammable": false
    },
    {
        "code": "R401B",
        "nom": "R401B (mélange R22 / R152a / R124)",
        "type": "HCFC/HFC (mélange)",
        "prg": null,
        "odp": 0.036,
        "inflammable": false
    },
    {
        "code": "R401C",
        "nom": "R401C (mélange R22 / R152a / R124)",
        "type": "HCFC/HFC (mélange)",
        "prg": null,
        "odp": 0.033,
        "inflammable": false
    },
    {
        "code": "R402A",
        "nom": "R402A (mélange R125 / R290 / R22)",
        "type": "HFC/Alcane/HCFC (mélange)",
        "prg": null,
        "odp": 0.019,
        "inflammable": false
    },
    {
        "code": "R402B",
        "nom": "R402B (mélange R125 / R290 / R22)",
        "type": "HFC/Alcane/HCFC (mélange)",
        "prg": null,
        "odp": 0.033,
        "inflammable": false
    },
    {
        "code": "R403A",
        "nom": "R403A (mélange R290 / R22 / R218)",
        "type": "Alcane/HCFC/PFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R403B",
        "nom": "R403B (mélange R290 / R22 / R218)",
        "type": "Alcane/HCFC/PFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R404A",
        "nom": "R404A (mélange R125 / R143a / R134a)",
        "type": "HFC (mélange)",
        "prg": 3922,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R405A",
        "nom": "R405A (mélange R22 / R152a / R142b / R218)",
        "type": "HCFC/HFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R406A",
        "nom": "R406A (mélange R22 / R600a / R142b)",
        "type": "HCFC/Alcane (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R407A",
        "nom": "R407A (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 2107,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407B",
        "nom": "R407B (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 2804,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407C",
        "nom": "R407C (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 1774,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407D",
        "nom": "R407D (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 1627,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407E",
        "nom": "R407E (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 1552,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407F",
        "nom": "R407F (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 1825,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407G",
        "nom": "R407G (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 1505,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R407H",
        "nom": "R407H (mélange R32 / R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 1495,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R408A",
        "nom": "R408A (mélange R125 / R143a / R22)",
        "type": "HFC/HCFC (mélange)",
        "prg": null,
        "odp": 0.026,
        "inflammable": false
    },
    {
        "code": "R409A",
        "nom": "R409A (mélange R22 / R124 / R142b)",
        "type": "HCFC (mélange)",
        "prg": null,
        "odp": 0.048,
        "inflammable": false
    },
    {
        "code": "R409B",
        "nom": "R409B (mélange R22 / R124 / R142b)",
        "type": "HCFC (mélange)",
        "prg": null,
        "odp": 0.045,
        "inflammable": false
    },
    {
        "code": "R410B",
        "nom": "R410B (mélange R32 / R125)",
        "type": "HFC (mélange R32 / R125)",
        "prg": 2229,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R411A",
        "nom": "R411A (mélange R1270 / R22 / R152a)",
        "type": "Alcène/HCFC/HFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R411B",
        "nom": "R411B (mélange R1270 / R22 / R152a)",
        "type": "Alcène/HCFC/HFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R412A",
        "nom": "R412A (mélange R22 / R218 / R142b)",
        "type": "HCFC/PFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R413A",
        "nom": "R413A (mélange R218 / R134a / R600a)",
        "type": "PFC/HFC/Alcane (mélange)",
        "prg": 2053,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R414A",
        "nom": "R414A (mélange R22 / R124 / R600a / R142b)",
        "type": "HCFC/Alcane (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R414B",
        "nom": "R414B (mélange R22 / R124 / R600a / R142b)",
        "type": "HCFC/Alcane (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R415A",
        "nom": "R415A (mélange R22 / R152a)",
        "type": "HCFC/HFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R415B",
        "nom": "R415B (mélange R22 / R152a)",
        "type": "HCFC/HFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R416A",
        "nom": "R416A (mélange R134a / R124 / R600)",
        "type": "HFC/HCFC/Alcane (mélange)",
        "prg": 1084,
        "odp": 0.01,
        "inflammable": false
    },
    {
        "code": "R417A",
        "nom": "R417A (mélange R125 / R134a / R600)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2346,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R417B",
        "nom": "R417B (mélange R125 / R134a / R600)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2578,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R417C",
        "nom": "R417C (mélange R125 / R134a / R600)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2283,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R418A",
        "nom": "R418A (mélange R290 / R22 / R152a)",
        "type": "Alcane/HCFC/HFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R419A",
        "nom": "R419A (mélange R125 / R134a / R600a / R600)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2967,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R419B",
        "nom": "R419B (mélange R125 / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2849,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R420A",
        "nom": "R420A (mélange R134a / R142b)",
        "type": "HFC/HCFC (mélange)",
        "prg": null,
        "odp": null,
        "inflammable": false
    },
    {
        "code": "R421A",
        "nom": "R421A (mélange R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 2631,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R421B",
        "nom": "R421B (mélange R125 / R134a)",
        "type": "HFC (mélange)",
        "prg": 2298,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R422A",
        "nom": "R422A (mélange R125 / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 3143,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R422B",
        "nom": "R422B (mélange R125 / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2526,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R422C",
        "nom": "R422C (mélange R125 / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 3085,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R422D",
        "nom": "R422D (mélange R125 / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2729,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R422E",
        "nom": "R422E (mélange R125 / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2456,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R423A",
        "nom": "R423A (mélange R134a / R227ea)",
        "type": "HFC (mélange)",
        "prg": 2280,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R424A",
        "nom": "R424A (mélange R125 / R134a / R600a / R600 / R601a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2440,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R425A",
        "nom": "R425A (mélange R32 / R134a / R227ea)",
        "type": "HFC (mélange)",
        "prg": 1505,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R426A",
        "nom": "R426A (mélange R125 / R134a / R600 / R601a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 1508,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R427A",
        "nom": "R427A (mélange R32 / R125 / R143a / R134a)",
        "type": "HFC (mélange)",
        "prg": 2138,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R428A",
        "nom": "R428A (mélange R125 / R143a / R290 / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 3607,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R429A",
        "nom": "R429A (mélange R600a / R152a / R600)",
        "type": "Alcane/HFC (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R430A",
        "nom": "R430A (mélange R152a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R431A",
        "nom": "R431A (mélange R290 / R152a)",
        "type": "Alcane/HFC (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R432A",
        "nom": "R432A (mélange R1270 / R600a)",
        "type": "Alcène/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R433A",
        "nom": "R433A (mélange R1270 / R290)",
        "type": "Alcène/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R433B",
        "nom": "R433B (mélange R1270 / R290)",
        "type": "Alcène/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R433C",
        "nom": "R433C (mélange R1270 / R290)",
        "type": "Alcène/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R434A",
        "nom": "R434A (mélange R125 / R143a / R134a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 3245,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R435A",
        "nom": "R435A (mélange R152a / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R436A",
        "nom": "R436A (mélange R290 / R600a)",
        "type": "Alcane (mélange)",
        "prg": 3,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R436B",
        "nom": "R436B (mélange R290 / R600a)",
        "type": "Alcane (mélange)",
        "prg": 3,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R437A",
        "nom": "R437A (mélange R125 / R134a / R600 / R601)",
        "type": "HFC/Alcane (mélange)",
        "prg": 1805,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R438A",
        "nom": "R438A (mélange R32 / R125 / R134a / R600 / R601a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 2265,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R439A",
        "nom": "R439A (mélange R32 / R125 / R600a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 1820,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R440A",
        "nom": "R440A (mélange R290 / R134a / R152a)",
        "type": "Alcane/HFC (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R441A",
        "nom": "R441A (mélange R170 / R290 / R600a / R600)",
        "type": "Alcane (mélange)",
        "prg": 3,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R442A",
        "nom": "R442A (mélange R32 / R125 / R134a / R152a / R227ea)",
        "type": "HFC (mélange)",
        "prg": 1888,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R443A",
        "nom": "R443A (mélange R1270 / R290 / R600a)",
        "type": "Alcène/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R444A",
        "nom": "R444A (mélange R32 / R152a / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 93,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R444B",
        "nom": "R444B (mélange R32 / R152a / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 295,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R445A",
        "nom": "R445A (mélange R744 / R134a / R1234ze(E))",
        "type": "Fluide naturel/HFC/HFO (mélange)",
        "prg": 146,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R446A",
        "nom": "R446A (mélange R32 / R1234ze(E) / R600)",
        "type": "HFC/HFO/Alcane (mélange)",
        "prg": 461,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R447A",
        "nom": "R447A (mélange R32 / R125 / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 573,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R447B",
        "nom": "R447B (mélange R32 / R125 / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 741,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R448A",
        "nom": "R448A (mélange R32 / R125 / R1234ze(E) / R134a / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 1273,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R449A",
        "nom": "R449A (mélange R32 / R125 / R1234yf / R134a)",
        "type": "HFC/HFO (mélange)",
        "prg": 1282,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R449B",
        "nom": "R449B (mélange R32 / R125 / R1234yf / R134a)",
        "type": "HFC/HFO (mélange)",
        "prg": 1412,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R449C",
        "nom": "R449C (mélange R32 / R125 / R1234yf / R134a)",
        "type": "HFC/HFO (mélange)",
        "prg": 1189,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R450A",
        "nom": "R450A (mélange R134a / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 605,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R451A",
        "nom": "R451A (mélange R1234yf / R134a)",
        "type": "HFO/HFC (mélange)",
        "prg": 329,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R451B",
        "nom": "R451B (mélange R1234yf / R134a)",
        "type": "HFO/HFC (mélange)",
        "prg": 296,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R452A",
        "nom": "R452A (mélange R32 / R125 / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 2140,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R452B",
        "nom": "R452B (mélange R32 / R125 / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 676,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R452C",
        "nom": "R452C (mélange R32 / R125 / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 77,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R453A",
        "nom": "R453A (mélange R32 / R125 / R134a / R227ea / R600 / R601a)",
        "type": "HFC/Alcane (mélange)",
        "prg": 1765,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R454A",
        "nom": "R454A (mélange R32 / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 239,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R454B",
        "nom": "R454B (mélange R32 / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 466,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R454C",
        "nom": "R454C (mélange R32 / R1234yf)",
        "type": "HFC/HFO (mélange)",
        "prg": 148,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R455A",
        "nom": "R455A (mélange R744 / R32 / R1234yf)",
        "type": "Fluide naturel/HFC/HFO (mélange)",
        "prg": 148,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R456A",
        "nom": "R456A (mélange R32 / R134a / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 687,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R457A",
        "nom": "R457A (mélange R32 / R1234yf / R152a)",
        "type": "HFC/HFO (mélange)",
        "prg": 139,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R458A",
        "nom": "R458A (mélange R32 / R125 / R134a / R227ea / R236fa)",
        "type": "HFC (mélange)",
        "prg": 1766,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R459A",
        "nom": "R459A (mélange R32 / R1234yf / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 459,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R459B",
        "nom": "R459B (mélange R32 / R1234yf / R1234ze(E))",
        "type": "HFC/HFO (mélange)",
        "prg": 284,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R460A",
        "nom": "R460A (mélange R32 / R125 / R1234yf / R134a)",
        "type": "HFC/HFO (mélange)",
        "prg": 1687,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R460B",
        "nom": "R460B (mélange R32 / R125 / R1234yf / R134a)",
        "type": "HFC/HFO (mélange)",
        "prg": 1430,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R460C",
        "nom": "R460C (mélange R32 / R125 / R1234yf / R134a)",
        "type": "HFC/HFO (mélange)",
        "prg": 1391,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R461A",
        "nom": "R461A (mélange R125 / R134a / R600a / R600 / R601a)",
        "type": "HFC/Alcane (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R463A",
        "nom": "R463A (mélange R744 / R32 / R125 / R1234yf / R134a)",
        "type": "Fluide naturel/HFC/HFO (mélange)",
        "prg": 1296,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R465A",
        "nom": "R465A (mélange R32 / R290 / R1234yf)",
        "type": "HFC/Alcane/HFO (mélange)",
        "prg": 109,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R466A",
        "nom": "R466A (mélange R32 / R125 / R13I1)",
        "type": "HFC (mélange)",
        "prg": 733,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "R470A",
        "nom": "R470A (mélange R32 / R134a / R744)",
        "type": "HFC/Fluide naturel (mélange)",
        "prg": null,
        "odp": 0,
        "inflammable": false
    },
    // ─── Éthers fluorés supplémentaires ──────────────────────────────────
    {
        "code": "RE245cb2",
        "nom": "Méthyl-pentafluoroéthyléther",
        "type": "Éther halogéné",
        "prg": 874,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE245fa2",
        "nom": "2,2,2-Trifluoroéthyl-difluorométhyléther",
        "type": "Éther halogéné",
        "prg": 286,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE347mcc",
        "nom": "Méthyl-heptafluoropropyléther",
        "type": "Éther halogéné",
        "prg": 530,
        "odp": 0,
        "inflammable": false
    },
    {
        "code": "RE347pcf2",
        "nom": "1,1,2,2-Tétrafluoroéthyl-2,2,2-trifluoroéthyléther",
        "type": "Éther halogéné",
        "prg": 889,
        "odp": 0,
        "inflammable": false
    },
    // ─── Gaz divers / autres ─────────────────────────────────────────────
    {
        "code": "R610",
        "nom": "Éther éthylique",
        "type": "Éther",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R611",
        "nom": "Formate de méthyle",
        "type": "Ester",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R630",
        "nom": "Méthylamine",
        "type": "Amine",
        "prg": null,
        "odp": 0,
        "inflammable": true
    },
    {
        "code": "R631",
        "nom": "Éthylamine",
        "type": "Amine",
        "prg": null,
        "odp": 0,
        "inflammable": true
    }
]